import React from "react";
import "./Footer.css";
import Scrolltop from "./Scrolltop";
import Analytics from "./Analytics";
import Floaticons from "./Floaticons";

function Footer() {
  const footerYear = new Date().getFullYear();

  return (
    <>
    <Floaticons/>
      <footer className="footer">
        <div className="footer-container">

          <div className="footer-left">
            © {footerYear} Accenture. All Rights Reserved. Accenture
            Confidential. For internal use only. Powered by Learning Experiences
            - L&TT, ATCI.
          </div>
          <Analytics/>
        </div>
      </footer>

      <Scrolltop />
    </>
  );
}

export default Footer;
